import { SelectOption, SchemaElement } from 'modules/events/types/eventsTypes';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  event: Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
  }),
  session: Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
  }),
  dateTime: Yup.date().required(),
  duration: Yup.string().required(),
  location: Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
  }),
  language: Yup.string().required(),
  category: Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
  }),
  segment: Yup.object().shape({
    id: Yup.number().required(),
    name: Yup.string().required(),
  }),
  productLine: Yup.object().shape({
    id: Yup.number().required(),
    name: Yup.string().required(),
  }),
  industry: Yup.object().shape({
    id: Yup.number().required(),
    name: Yup.string().required(),
  }),
  region: Yup.object().shape({
    id: Yup.number().required(),
    name: Yup.string().required(),
  }),
  marketingLabel: Yup.string().required(),
  description: Yup.string().required(),
  logo: Yup.mixed().required(),
});

export const getFormSchema = (properties: Record<string, SelectOption[]>): SchemaElement[] => [
  {
    name: 'event',
    label: 'Select event',
    type: 'autocomplete',
  },
  {
    name: 'session',
    label: 'Select session',
    type: 'autocomplete',
  },
  {
    name: 'dateTime',
    label: 'Date and time',
    type: 'date-time',
    width: 3,
  },
  {
    name: 'duration',
    label: 'Duration',
    width: 3,
  },
  {
    name: 'location',
    label: 'Location',
    type: 'autocomplete',
    width: 3,
    options: properties.locations,
  },
  {
    name: 'language',
    label: 'Language',
    width: 3,
  },
  {
    name: 'category',
    label: 'Category',
    type: 'autocomplete',
    width: 6,
    options: properties.categories,
  },
  {
    name: 'segment',
    label: 'Segment',
    type: 'autocomplete',
    width: 6,
    options: properties.segments,
  },
  {
    name: 'productLine',
    label: 'Product Line',
    type: 'autocomplete',
    width: 6,
    options: properties.productLines,
  },
  {
    name: 'industry',
    label: 'Industry',
    type: 'autocomplete',
    width: 6,
    options: properties.industries,
  },
  {
    name: 'region',
    label: 'Region',
    type: 'autocomplete',
    width: 6,
    options: properties.regions,
  },
  {
    name: 'marketingLabel',
    label: 'Marketing Label',
    width: 6,
  },
  {
    name: 'description',
    label: 'Edit description',
    type: 'rich-text',
  },
  {
    name: 'actionsColumn',
    type: 'group',
    width: 6,
    controls: [
      {
        name: 'documents',
        label: 'Documents',
        type: 'documents',
      },
      {
        name: 'activeEvent',
        label: 'Active event',
        type: 'checkbox',
      },
    ],
  },
  {
    name: 'logo',
    label: 'Upload image',
    type: 'image',
    width: 6,
  },
];
